import { PriorityBadge, StatusBadge } from "./Badges";

export default function ActionsView({ lane, actions, contacts, onToggle, onOpen }) {
  const isPre = lane === "pre";
  const list = actions.filter((a) => (isPre ? a.lane !== "Post-ADE" : a.lane === "Post-ADE"));
  const queue = isPre
    ? contacts.filter((c) => ["Not Sent", "Sent", "No Response"].includes(c.outreachStatus) && c.outreachStatus !== "Passed")
    : contacts.filter((c) => c.followUpNeeded === "Yes" || ["Replied", "Meeting Booked"].includes(c.outreachStatus));
  const done = list.filter((a) => a.done).length;

  return (
    <div className="grid lg:grid-cols-[1.1fr_1fr] gap-5" data-testid={`${lane}-ade-view`}>
      <section className="card p-5">
        <div className="flex items-baseline justify-between mb-4">
          <div>
            <div className="eyebrow">{isPre ? "Lane 1 · Warm meeting outreach" : "Lane 2 · Formal music follow-up"}</div>
            <h2 className="text-xl font-extrabold mt-1">{isPre ? "Pre-ADE & ADE week" : "Post-ADE (24–72h)"}</h2>
          </div>
          <span className="mono text-xs" style={{ color: "var(--text-2)" }} data-testid="actions-progress">{done}/{list.length} done</span>
        </div>
        <ul className="space-y-2">
          {list.map((a) => (
            <li key={a.id} className="flex items-start gap-3 p-3 rounded-xl" style={{ background: "var(--surface-2)", opacity: a.done ? 0.55 : 1, transition: "opacity 160ms ease" }} data-testid={`action-${a.id}`}>
              <input type="checkbox" className="check mt-0.5" checked={!!a.done} onChange={(e) => onToggle(a, e.target.checked)} data-testid={`action-checkbox-${a.id}`} />
              <div className="flex-1">
                <div className="text-sm" style={{ textDecoration: a.done ? "line-through" : "none" }}>{a.title}</div>
                <div className="mono text-[11px] mt-1" style={{ color: a.lane === "ADE Week" ? "var(--cyan)" : "var(--amber)" }}>{a.window} · {a.lane}</div>
              </div>
            </li>
          ))}
        </ul>
      </section>

      <section className="card p-5">
        <div className="eyebrow">{isPre ? "Still to contact / awaiting reply" : "Follow-up queue"}</div>
        <h2 className="text-xl font-extrabold mt-1 mb-4">{queue.length} {isPre ? "targets" : "people"}</h2>
        <ul className="space-y-2" data-testid="actions-queue">
          {queue.map((c) => (
            <li key={c.id} onClick={() => onOpen(c)} className="flex items-center gap-3 p-3 rounded-xl cursor-pointer" style={{ background: "var(--surface-2)" }} data-testid={`queue-item-${c.id}`}>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{c.targetName}</div>
                <div className="text-xs truncate" style={{ color: "var(--text-2)" }}>{c.company}</div>
              </div>
              <PriorityBadge value={c.priority} />
              {isPre ? <StatusBadge value={c.outreachStatus} /> : (
                <span className="badge" style={{ color: c.followUpSent === "Yes" ? "#34D399" : "#FCD34D", borderColor: "var(--border)", background: "transparent" }}>
                  {c.followUpSent === "Yes" ? "Follow-up sent" : "Follow-up due"}
                </span>
              )}
            </li>
          ))}
          {!queue.length && <li className="text-sm p-3" style={{ color: "var(--text-2)" }}>Nothing here yet — mark contacts as Replied / Meeting Booked or set “Follow-up needed: Yes”.</li>}
        </ul>
      </section>
    </div>
  );
}
